<template>
  <div class="home">
    <Swiper class="swiper_c"/>
    <homeAbout/>
    <homeProduct/>
    <!-- <homeSolve/> -->
    <homePartner/>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper';

import homeAbout from './homeAbout';
import homeProduct from './homeProduct';
import homeSolve from './homeSolve';
import homePartner from './homePartner';

export default {
  components: {
    Swiper,
    homeAbout,
    homeProduct,
    homeSolve,
    homePartner
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    // this._getDepartmentList({page: 1, size: 10})
    // this._getDepartmentList2({page: 1, size: 10})
  },
  methods: {
    // _getDepartmentList(params) {
    //   getDepartmentList(params).then(res => {
    //     console.log('getDepartmentList', res);
    //     this.list = res.data
        
    //     console.log(' this.list',  this.list);
        
    //     // 全局 函数
    //     const t = this.mySum('aa', 'nbn')
    //     console.log('t', t)
    //   })
    // },
    // async _getDepartmentList2(params) {
    //   const res = await getDepartmentList(params)
    //   console.log('getDepartmentList 2222', res);
    // }
  }
}
</script>

<style scoped>
  .home{
    background-color: #F7F7F7;
  }
  .swiper_c{
    width: 100%;
    height: 500px;
  }
</style>